import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/CurrencyBitcoin';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { Stripe } from "stripe";
import CardActionArea from "@mui/material/CardActionArea";
import { alpha, useTheme } from '@mui/material/styles';

interface SubscriptionItemProps
{
  product: Stripe.Product
  setSelectedProductId: (id: string) => void
  selectedProductId: string
}

export const SubscriptionItem = ({ setSelectedProductId, product, selectedProductId }: SubscriptionItemProps) =>
{
  const theme = useTheme()
  const isSelected = selectedProductId === product.id
  return(
    <CardActionArea sx={styles.action(theme, isSelected)} onClick={() => setSelectedProductId(product.id === selectedProductId ? "" : product.id)}>
    <ListItem sx={styles.item}>
    <ListItemAvatar>
      <Avatar sx={styles.avatar(theme, isSelected)}>
        { isSelected ? <CheckCircle color="primary" /> : <ImageIcon />} 
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary={product.name} secondary={product.description} />
  </ListItem>
  </CardActionArea>
  )
}

const styles = {
  action: (theme: any, isSelected: boolean) => ({
    borderRadius: "12px",
    border: `1px solid ${isSelected ? alpha(theme.palette.info.main, 0.45) : alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.35)}`,
    backgroundColor: isSelected
      ? alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.12 : 0.08)
      : alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.02 : 0.5),
    '& + &': {
      marginTop: 2,
    },
  }),
  item: {
  },
  avatar: (theme: any, isSelected: boolean) => ({
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.75),
    color: isSelected ? theme.palette.info.main : theme.palette.text.primary,
  }),
}
